<template>
  <div
    class="container mx-auto max-w-xl px-4 p-1 bg-basic-dark shadow-md drop-shadow-2xl lg:p-2 rounded-md place-items-center text-white text-center md:mt-36 border border-gray-600"
  >
    <h1 class="text-2xl font-bold mb-4">مرحبا بك في زاخر</h1>
    <p class="mb-6 text-sm">
      استمتع بمحتوى حصري ومميز على منصتنا. اشترك الآن للوصول إلى مكتبة ضخمة من الفيديوهات
      والبرامج.
    </p>
    <div class="flex flex-col space-y-4 w-full p-4">
      <select
        v-if="getZakhirPlans.length"
        v-model="selectedPlanUuid"
        class="w-full rounded-md border border-gray-600 p-3 text-right bg-basic-dark text-white"
        dir="rtl"
      >
        <option
          v-for="plan in getZakhirPlans"
          :key="plan.plan_uuid"
          :value="plan.plan_uuid"
        >
          {{ plan.name }} - {{ plan.price }} {{ plan.currency }}
        </option>
      </select>

      <sudan-phone-input
        v-model="phone"
        :disabled="disabled"
        id="zakhir-phone"
        @valid="handlePhoneValidation"
      />
      <button
        @click="initPayment"
        type="button"
        :disabled="disabled"
        class="w-full bg-pink-600 hover:bg-pink-700 disabled:opacity-50 disabled:cursor-not-allowed text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
      >
        {{ disabled ? "جاري التحقق..." : "اشترك الآن" }}
      </button>
      <!-- agree for terms and condirtions checkbox -->
      <div class="space-x-2">
        <label for="accept" class="text-sm">أوافق على تجديد الإشتراك تلقائيا </label>
        <input
          type="checkbox"
          v-model="accepted"
          id="accept"
          name="accept"
          class="inline-block"
        />
      </div>
    </div>
  </div>
</template>

<script>
import SudanPhoneInput from "@/components/SudanPhoneInput.vue";
import { mapActions, mapState } from "pinia";
import { useZakhirStore } from "@/stores/zakhir";
import { useToast } from "vue-toastification";
import { USER } from "@/constants";

export default {
  components: {
    SudanPhoneInput,
  },
  data() {
    return {
      phone: "",
      phoneValidation: null,
      disabled: false,
      accepted: false,
      toast: useToast(),
      selectedPlanUuid: null,
    };
  },
  computed: {
    ...mapState(useZakhirStore, ["getZakhirPlans"]),
    selectedPlan() {
      return (
        this.getZakhirPlans.find((plan) => plan.plan_uuid === this.selectedPlanUuid) ||
        null
      );
    },
  },
  methods: {
    ...mapActions(useZakhirStore, ["fetchZakhirPlans", "sendZakhirOtp"]),
    handlePhoneValidation(result) {
      this.phoneValidation = result;
    },
    async initPayment() {
      if (!this.phoneValidation?.valid) {
        this.toast.error(this.phoneValidation?.message || "رقم الهاتف غير صحيح");
        return;
      }

      if (!this.accepted) {
        this.toast.warning("يرجى الموافقة على الشروط والأحكام");
        return;
      }

      if (!this.selectedPlan) {
        this.toast.error("لا توجد باقة متاحة حاليا");
        return;
      }
      // get user_id from query params or localStorage under they key of user
      const user =  localStorage.getItem(USER);
      const user_data = user ? JSON.parse(user) : null;
      const userId =  user_data?.id
      if (!userId) {
        this.toast.error("تعذر التعرف على المستخدم");
        return;
      }

      this.disabled = true;
      const formattedPhone = this.phoneValidation.phone;

      try {
        const response = await this.sendZakhirOtp(formattedPhone);
        if (response.success) {
          localStorage.setItem("zakhirPhoneNumber", formattedPhone);
          localStorage.setItem("zakhirPlanUuid", this.selectedPlan.plan_uuid);
          localStorage.setItem("zakhirUserId", userId);
          this.$router.push({ name: "auth.zakhir.verify-otp" });
        } else {
          this.toast.error(response.message || "تعذر إرسال رمز التأكيد");
          this.disabled = false;
        }
      } catch (error) {
        const errorCode = error?.response?.data?.errorCode;
        const messages = {
          ZAKHIR_CUSTOMER_NOT_FOUND: "لا يوجد حساب زاخر مرتبط بهذا الرقم",
          OTP_SEND_FAILED: "تعذر إرسال رمز التأكيد",
          VALIDATION_ERROR: "بيانات غير صحيحة",
          USER_NOT_FOUND: "المستخدم غير موجود",
        };
        this.toast.error(messages[errorCode] || "حدث خطأ أثناء الاشتراك، حاول مرة أخرى");
        console.error("Error initiating Zakhir payment:", error);
        this.disabled = false;
      }
    },
  },
  async created() {
    const userID = this.$route.query.user_id;
    const origin = this.$route.query.origin || "web";
    localStorage.setItem("origin", origin);
    if (userID) {
      localStorage.setItem("user_id_sub", userID);
    }

    try {
      await this.fetchZakhirPlans();
      this.selectedPlanUuid = this.getZakhirPlans?.[0]?.plan_uuid || null;
    } catch (error) {
      this.toast.error("تعذر تحميل باقات زاخر");
    }
  },
};
</script>

<style lang="scss" scoped></style>
